import Route from '@ember/routing/route';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';
import { PopupEvent } from 'webapp/enums/enums';
import type { NotificationCreateType } from 'webapp/enums/notifications';

import type { ModelWithNotificationForPopup } from 'webapp/services/model-manager/notifications';

export default class SettingsNotificationsEditRoute extends Route {
	@service('navigation') declare navigationService: Service.Navigation;
	@service('billing') declare billingService: Service.Billing;
	@service('model-manager/notifications')
	declare mmNotificationsService: Service.ModelManager.Notifications;

	override model(params: { id: string }): ModelWithNotificationForPopup | null {
		const type = this.getTypeParam();
		const model = this.mmNotificationsService.getModelForTypeAndId(type, params.id);
		return model;
	}

	override afterModel(model: ModelWithNotificationForPopup | null) {
		if (!model) {
			return this.returnToRoot();
		}

		if (!this.billingService.sharingEnabled) {
			return this.returnToRoot();
		}

		const type = this.getTypeParam();
		const limitation = this.mmNotificationsService.checkLimitationForCreateType(type);
		if (limitation) {
			this.returnToRoot().then(() => {
				this.billingService.handleLimitations(limitation);
			});
		} else {
			this.openEditPopup(model);
		}
	}

	private getTypeParam() {
		const typeParams = this.paramsFor('settings.notifications.type') as {
			type: NotificationCreateType;
		};
		return typeParams.type;
	}

	private openEditPopup(model: ModelWithNotificationForPopup) {
		const popup = this.mmNotificationsService.openEditPopup(model, 'notifications');
		if (popup) {
			popup.on(PopupEvent.CLOSING, this, () => {
				this.returnToRoot();
			});
		}
	}

	private returnToRoot() {
		return this.navigationService.replaceRoute('settings.notifications');
	}
}
